import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-step-one-mautic',
  templateUrl: './step-one-mautic.component.html',
  styleUrls: ['./step-one-mautic.component.scss']
})
export class StepOneMauticComponent implements OnInit {

  formData: any = {};
  @ViewChild('form', { static: false }) form: ElementRef<any>;

  constructor(
    router: ActivatedRoute,
    @Inject('FORM_API_URL') public formApiUrl: string
  ) {

    router.queryParams.subscribe(
      query => {
        this.formData = {
          email: query.email,
          cpf: query.cpf,
          password: query.password,
          phone: query.phone,
          mobile: query.mobile,
          firstname: query.firstname,
          lastname: query.lastname,
          desiredJobTitle: query.desiredJobTitles,
          aboutme: query.aboutme
        }
        
        setTimeout(() => this.form.nativeElement.submit(), 500);

      }
    )

  }

  ngOnInit(): void {

  }

}
